import * as NavConstants from 'constants/NavConstants';
import {getStore} from 'redux-stores/Store';
import {maybeRefreshListing} from 'search/SearchUIReduxActions';

export function refreshProjectsListing(): void {
  // This may be called before the projects listing is opened, in which case it should no-op
  getStore().dispatch(maybeRefreshListing(NavConstants.SECTIONS.PROJECTS));
}
